/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreateStateDutyOrderRequest
 */
export interface CreateStateDutyOrderRequest {
  /**
   * Имя продукта пошлины
   * @type {string}
   * @memberof CreateStateDutyOrderRequest
   */
  productName: string
  /**
   *
   * @type {number}
   * @memberof CreateStateDutyOrderRequest
   */
  ownerSystemObjectId: number
  /**
   *
   * @type {string}
   * @memberof CreateStateDutyOrderRequest
   */
  currencyName: string
}

/**
 * Check if a given object implements the CreateStateDutyOrderRequest interface.
 */
export function instanceOfCreateStateDutyOrderRequest(
  value: object
): value is CreateStateDutyOrderRequest {
  if (!('productName' in value) || value['productName'] === undefined)
    return false
  if (
    !('ownerSystemObjectId' in value) ||
    value['ownerSystemObjectId'] === undefined
  )
    return false
  if (!('currencyName' in value) || value['currencyName'] === undefined)
    return false
  return true
}

export function CreateStateDutyOrderRequestFromJSON(
  json: any
): CreateStateDutyOrderRequest {
  return CreateStateDutyOrderRequestFromJSONTyped(json, false)
}

export function CreateStateDutyOrderRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateStateDutyOrderRequest {
  if (json == null) {
    return json
  }
  return {
    productName: json['productName'],
    ownerSystemObjectId: json['ownerSystemObjectId'],
    currencyName: json['currencyName'],
  }
}

export function CreateStateDutyOrderRequestToJSON(
  value?: CreateStateDutyOrderRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    productName: value['productName'],
    ownerSystemObjectId: value['ownerSystemObjectId'],
    currencyName: value['currencyName'],
  }
}
